var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"faq-article",class:{open: _vm.openState}},[_c('div',{staticClass:"faq-article-title",on:{"click":_vm.toggle}},[_vm._v("\n    "+_vm._s(_vm.article.texts.title)+"\n  ")]),_vm._v(" "),_c('div',{staticClass:"faq-article-content"},[_c('div',{staticClass:"body",domProps:{"innerHTML":_vm._s(_vm.article.texts.body)}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-68359318","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/faq/article.vue
// module id = null
// module chunks = 